import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportDriverGradesCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'

export const ExportDriverGrades = () => {
  const translations = useTranslate({
    driverGrades: 'driver-grades.driver-grades',
  })

  return (
    <ExportSection header={translations.driverGrades}>
      <ExportDriverGradesCard />
    </ExportSection>
  )
}
